import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { TicketCategory } from '../models/entities/ticket-category-entity';
import { TicketStatus } from '../models/entities/ticket-status-entity';
import { Ticket } from '../models/entities/ticket';
import { TicketRequest } from '../models/dto/ticket-request';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { TicketBatch } from '../models/entities/ticket-batch';
import { TicketBatchRequest } from '../models/dto/ticket-batch-request';
import { TicketBatchTicket } from '../models/entities/ticket-batch-ticket';
import { TicketBatchTicketRequest } from '../models/dto/ticket-batch-ticket-request';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';


@Injectable({
    providedIn: 'root'
})
export class TicketService {

    constructor(
        private networkService: LeanNetworkService,
        public userService : UserService) {
    }

    
    ticketCategorysGet(): Promise<TicketCategory[]> {
        let request = new BaseRequest(this.userService.userInfo);
        return new Promise((resolve, reject) => {
            this.networkService.post('services/controls/ticketCategorysGet', request).then(result => {
                return resolve(result.ticketCategorys);
            }, error => {
                reject(error);
            });
        });
    }
    
    ticketStatusGet(): Promise<TicketStatus[]> {
        let request = new BaseRequest(this.userService.userInfo);
        return new Promise((resolve, reject) => {
            this.networkService.post('services/controls/ticketStatusesGet', request).then(result => {
                return resolve(result.ticketStatuses);
            }, error => {
                reject(error);
            });
        });
    }
    
    ticketCandidatesGet(ticketCode : string): Promise<Person[]> {
        let request = new BaseRequest(this.userService.userInfo);
        request.strArg1 = ticketCode;
        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketCandidatesGet', request).then(result => {
                return resolve(result.persons);
            }, error => {
                reject(error);
            });
        });

    }

    
    personTicketsGet(personCode : string): Promise<Ticket[]> {
        let request = new BaseRequest(this.userService.userInfo);
        request.strArg1 = personCode;
        request.blnArg1 = false;
        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/personTicketsGet', request).then(result => {
                return resolve(result.tickets);
            }, error => {
                reject(error);
            });
        });

    }

    //------------------------------------------------------------------------------------
    // Tickets Get
    //------------------------------------------------------------------------------------
    ticketsGet(
        id                      : number,
        ticketCategoryId        : number,
        ticketTypeId            : number,
    
        branchCode              : string,
        partnerCode             : string,
        itineraryCode           : string,
    
        assetBarCode            : string,
        assetProductCategoryCode: string,
    
        priority                : number,
    
        newlyCreated_PL 		: boolean,
        toBeQualified_PL        : boolean,
        qualified_PL            : boolean,
        scheduled_PL            : boolean,
        processed_PL            : boolean,
        closed_PL               : boolean,
        ticketBatchId?          : number): Promise<Ticket[]> {

        let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
        request.id          = id;

        request.lngArg1     = ticketBatchId;
        request.lngArg2     = ticketCategoryId;
        request.lngArg3     = ticketTypeId;
        request.lngArg4     = priority;
       
        request.strArg1     = branchCode;
        request.strArg2     = partnerCode;
        request.strArg3     = itineraryCode;
        request.strArg4     = assetBarCode;
        request.strArg5     = assetProductCategoryCode;

        request.blnArg1     = newlyCreated_PL;
        request.blnArg2     = toBeQualified_PL;
        request.blnArg3     = qualified_PL;
        request.blnArg4     = scheduled_PL;
        request.blnArg5     = processed_PL;
        request.blnArg6     = closed_PL;

        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketsGet', request).then(result => {
              resolve(result.tickets);
            }, error => {
                reject(error);
            });
        });
    }
    ticketGet(ticketid : number): Promise<Ticket> {
        let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
        request.id          = ticketid;

        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketGet', request).then(result => {
              resolve(result.ticket);
            }, error => {
                reject(error);
            });
        });
    }
    
    ticketSave(ticket : Ticket, requestService : string) : Promise<Ticket>{
        let request: TicketRequest = new TicketRequest(this.userService.userInfo);
        request.ticket = ticket;
        request.service = requestService;

        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketSave', request).then(result => {                
                let ticket : Ticket = result.ticket;
                return resolve(ticket);
            }, error => {
                reject(error);
            });
        });
    }

    

    //------------------------------------------------------------------------------------
    // Ticket Batch
    //------------------------------------------------------------------------------------
    ticketBatchsGet(
        ticketBatchCode : string,
        branchCode      : string,
        progressLevel   : number,
        startDate       : Date,
        endDate         : Date   
        ): Promise<TicketBatch[]> {

        let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
        request.code        = ticketBatchCode;
        request.strArg1     = branchCode;
        request.dteArg1     = startDate;
        request.dteArg1     = endDate;


        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketBatchsGet', request).then(result => {
              resolve(result.ticketBatchs);
            }, error => {
                reject(error);
            });
        });
    }
    ticketBatchGet(ticketBatchId : number): Promise<TicketBatch> {

        let request       : BaseRequest = new BaseRequest(this.userService.userInfo);
        request.id        = ticketBatchId;

        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketBatchGet', request).then(result => {
              resolve(result.ticketBatch);
            }, error => {
                reject(error);
            });
        });
    }

    ticketBatchSave(ticketBatch : TicketBatch) : Promise<TicketBatch>{
        let request: TicketBatchRequest = new TicketBatchRequest(this.userService.userInfo);
        request.ticketBatch = ticketBatch;

        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketBatchSave', request).then(result => {                
                return resolve(result.ticketBatch);
            }, error => {
                reject(error);
            });
        });
    }

    ticketBatchClose(ticketBatch : TicketBatch) : Promise<TicketBatch>{
        let request: TicketBatchRequest = new TicketBatchRequest(this.userService.userInfo);
        request.ticketBatch = ticketBatch;

        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketBatchClose', request).then(result => {                
                return resolve(result.ticketBatch);
            }, error => {
                reject(error);
            });
        });
    }



    ticketBatchTicketGet(ticketBatchTicketId : number): Promise<TicketBatchTicket> {

        let request       : BaseRequest = new BaseRequest(this.userService.userInfo);
        request.id        = ticketBatchTicketId;

        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketBatchTicketGet', request).then(result => {
              resolve(result.ticketBatchTicket);
            }, error => {
                reject(error);
            });
        });
    }

    ticketBatchTicketClose(ticketBatchTicket : TicketBatchTicket): Promise<TicketBatchTicket> {

        let request                 : TicketBatchTicketRequest = new TicketBatchTicketRequest(this.userService.userInfo);
        request.ticketBatchTicket   = ticketBatchTicket;

        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketBatchTicketClose', request).then(result => {
              resolve(result.ticketBatchTicket);
            }, error => {
                reject(error);
            });
        });
    }

    
    ticketBatchTicketDelete(ticketBatchTicket : TicketBatchTicket): Promise<Boolean> {

        let request                 : TicketBatchTicketRequest = new TicketBatchTicketRequest(this.userService.userInfo);
        request.ticketBatchTicket   = ticketBatchTicket;

        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketBatchTicketDelete', request).then(result => {
              resolve(true);
            }, error => {
                reject(error);
            });
        });
    }

    
    assetSparesGet(assetCode : string): Promise<AssetProduct[]> {
        let request   : BaseRequest = new BaseRequest(this.userService.userInfo);
        request.code   = assetCode;

        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/assetSparesGet', request).then(result => {
              resolve(result.assetProducts);
            }, error => {
                reject(error);
            });
        });
    }

    documentSave(tbt : TicketBatchTicket) : Promise<TicketBatch>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.lngArg1      = tbt.ticketBatch.id;
        request.lngArg2      = tbt.ticket.id;
        request.strArg3      = tbt.document;

        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/ticketDocumentSave', request).then(result => {                
                return resolve(result.ticketBatch);
            }, error => {
                reject(error);
            });
        });
    }
 


    xtrnTicketsGet(): Promise<Ticket[]> {
        let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/xtrnTicketsGet', request).then(result => {
              resolve(result.tickets);
            }, error => {
                reject(error);
            });
        });
    }

    xtrnTicketsProcess(): Promise<Ticket[]> {
        let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/xtrnTicketsProcess', request).then(result => {
                resolve(result.tickets);
            }, error => {
                reject(error);
            });
        });
    }
    
   
    xtrnTicketsLoad(stream : string): Promise<Ticket[]> {
        let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = stream;
        return new Promise((resolve, reject) => {
            this.networkService.post('services/ticket/xtrnTicketsLoad', request).then(result => {
                resolve(result.tickets);
            }, error => {
                reject(error);
            });
        });
    }
}
